import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const EMPTY = { name: "", email: "", organization: "", city: "", event_date: "", budget: "", message: "" };
const f = "h-11 border-white/10 bg-[#07090E]";

export const BookingDialog = ({ artist }) => {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/artists/${artist.slug}/booking`, v);
      toast.success(`Request sent to ${artist.stage_name}`, { description: "They'll reply directly to your email." });
      setV(EMPTY); setOpen(false);
    } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <>
      <button className="btn-ghost mt-3 w-full" onClick={() => setOpen(true)} data-testid="booking-open-button"><CalendarPlus className="h-4 w-4" />Book {artist.stage_name}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto border-white/10 bg-[#0F1420] text-white" data-testid="booking-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Book {artist.stage_name}</DialogTitle>
            <DialogDescription className="text-slate-400">For venues, festivals, clubs and organizers. Your request goes straight to the artist.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3" data-testid="booking-form">
            <div className="grid gap-3 sm:grid-cols-2">
              <Input required placeholder="Your name" value={v.name} onChange={set("name")} className={f} data-testid="booking-name" />
              <Input required type="email" placeholder="Email" value={v.email} onChange={set("email")} className={f} data-testid="booking-email" />
              <Input placeholder="Venue / organization" value={v.organization} onChange={set("organization")} className={f} data-testid="booking-organization" />
              <Input placeholder="City" value={v.city} onChange={set("city")} className={f} data-testid="booking-city" />
              <Input type="date" value={v.event_date} onChange={set("event_date")} className={f} data-testid="booking-date" />
              <Input placeholder="Budget (optional)" value={v.budget} onChange={set("budget")} className={f} data-testid="booking-budget" />
            </div>
            <Textarea required minLength={10} rows={5} placeholder="Tell them about the event: type, set length, audience…" value={v.message} onChange={set("message")} className="border-white/10 bg-[#07090E]" data-testid="booking-message" />
            <button className="btn-hot w-full" disabled={busy} data-testid="booking-submit">{busy ? "Sending…" : "Send booking request"}</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
